import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  email: "",
  fullname: "",
  first_name: "",
  last_name: "",
  main_img: null,
  phone: "",
  token: "",
  admin_type_id: 0,
  admin_type_name: "",
  role_id: null,
  role_name: "",
  is_doctor: false,
  username: "",
  dataPrivileges: [],
};

export const UserSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.id = action?.payload?.id;
      state.email = action?.payload?.email;
      state.fullname = action?.payload?.fullname;
      state.first_name = action?.payload?.first_name;
      state.last_name = action?.payload?.last_name;
      state.main_img = action?.payload?.main_img;
      state.phone = action?.payload?.phone;
      state.token = action?.payload?.token;
      state.admin_type_id = action?.payload?.admin_type_id;
      state.admin_type_name = action?.payload?.admin_type_name;
      state.role_id = action?.payload?.role_id;
      state.role_name = action?.payload?.role_name;
      state.is_doctor = Boolean(action?.payload?.is_doctor);
      state.username = action?.payload?.username;
    },
    removeUserInfo: () => initialState,
    setDataPrivileges: (state, action) => {
      state.dataPrivileges = action.payload;
    },
  },
});

export const { setUserInfo, setDataPrivileges, removeUserInfo } =
  UserSlice.actions;

export default UserSlice.reducer;
